module.exports = __webpack_public_path__ + "static/nowoczesne-rozwiazania-2-c57be66a00ed9de5adc90a334eeaf808.jpg";